module.exports = __webpack_public_path__ + "img/137.6021b679.png";